// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paymentError {
  color: #d8000c;
  background-color: #ffbaba;
  padding: 10px;
}

.paymentError label {
  color: #d8000c;
}`, "",{"version":3,"sources":["webpack://./src/app/agent/agent-payment-view/agent-payment-view.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,yBAAA;EAEA,aAAA;AAAF;;AAEA;EACE,cAAA;AACF","sourcesContent":[".paymentError {\r\n  color: #d8000c;\r\n  background-color: #ffbaba;\r\n  // text-align: center;\r\n  padding: 10px;\r\n}\r\n.paymentError label {\r\n  color: #d8000c;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
